import { SEVERITY_LEVELS } from "../../../constants";
import template from "./index.html";
import "./index.less";
import { isTextMarkdown } from "../isTextMarkdown";
import marked from "marked";

export function controller(
	$logger, 
	$scope,
	$sce,
	noticeService,
	loadingService
) {
	const ctrl = this;

	ctrl.$onInit = onInit;

	function onInit() {
		refreshDataFromService();

		$scope.$watch(() => noticeService.notices, (next, prev) => {
			if(next !== prev) {
				refreshDataFromService(next);
			}
		});
	}

	ctrl.markRead = (noticeId) => {
		const reading = noticeService.readNotice(noticeId)
			.then(() => {
				refreshDataFromService();
			});

		loadingService.watch(reading);
	};

	function refreshDataFromService(notices) {
		ctrl.hasUnreadNotices = noticeService.hasUnreadNotices;
		notices = notices ?? noticeService.notices;

		ctrl.notices = [...notices]
			.filter(n => noticeService.isNoticeValid(n))
			.filter(n => noticeService.showNoticeUnread(n))
			.sort((a, b) => {
				const aOrder = SEVERITY_LEVELS[a.Severity.Code]?.order ?? SEVERITY_LEVELS["UNKNOWN"].order;
				const bOrder = SEVERITY_LEVELS[b.Severity.Code]?.order ?? SEVERITY_LEVELS["UNKNOWN"].order;

				return aOrder - bOrder;
			})
			.map(n => ({
				notice: {
					...n,
					Content: isTextMarkdown(n.Content) ? $sce.trustAsHtml(marked(n.Content)) : $sce.trustAsHtml(n.Content),
					isContentMarkdown: isTextMarkdown(n.Content)
				},
				severityDetails: SEVERITY_LEVELS[n.Severity.Code] ?? SEVERITY_LEVELS["UNKNOWN"]
			}));
	}
}

export default angular
	.module("vesl.components.notice-banner", [])
	.component("noticeBanner", {
		template,
		controller
	}).name;
